import React, { useState } from "react";
import "./sessiontimings.scss";
import { Link } from "react-router-dom";
import { Badge, Col, Nav, Row, Tab } from "react-bootstrap";

const dates = [
  { day: "Fri", date: "31" },
  { day: "Sat", date: "01" },
  { day: "Sun", date: "02" },
  { day: "Mon", date: "03" },
  { day: "Tue", date: "04" },
  { day: "Fri", date: "31" },
  { day: "Sat", date: "01" },
  { day: "Sun", date: "02" },
  { day: "Mon", date: "03" },
  { day: "Tue", date: "04" }
];

const slots = [
  "9.00-10:00", "10:00-10:30", "10:30-11:00", "11:00-11:30", "11:30-12:00",
  "12:00-12:30", "12:30-01:00", "01:00-01:30", "01:30-02:00", "02:00-02:30",
  "02:30-03:00", "03:00-03:30", "03:30-04:00", "04:00-04:30", "04:30-05:00"
];

export default function Sessionrequests() {
  const [activeDate, setActiveDate] = useState(2);
  const [selectedSlot, setSelectedSlot] = useState(0);

  return (
    <div className="container py-4">

      <h4 className='mt-3 font-bold mb-4'><Link to="/homepage"><svg width="35" height="35" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="43" height="43" rx="4.5" stroke="#161616" stroke-opacity="0.3" />
        <path d="M25.8865 31.6615L16.165 21.9999L25.8865 12.3384L27.1748 13.6267L18.8016 21.9999L27.1748 30.3732L25.8865 31.6615Z" fill="#161616" />
      </svg></Link>&nbsp;
        Session Timings</h4>
      <p>Review and manage your upcoming sessions</p>

      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <div className="pending-card d-flex justify-content-between align-items-center">

          {/* Left Content */}
          <div>
            <div className="">Pending Requests</div>
            <div className="font-bold">40</div>
          </div>

          {/* Button */}
          <button className="btn accept-btn">
            Accept All
          </button>

        </div>
        <Row>
          <Col sm={12}>
            <Nav variant="underline" className="d-flex justify-content-start gap-4">
              <Nav.Item>
                <Nav.Link eventKey="first">Pending</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">Accepted</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="three">Completed</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={12}>
            <Tab.Content className="py-3">
              <Tab.Pane eventKey="first">{/* date slider */}
                <div className="date-strip d-flex align-items-center justify-content-between px-3 py-3 mb-4">
                  <button className="nav-btn">‹</button>
                  <div className="d-flex gap-4 overflow-auto">
                    {dates.map((d, i) => (
                      <div
                        key={i}
                        className={`date-item text-center ${activeDate === i ? "active" : ""}`}
                        onClick={() => setActiveDate(i)}
                      >
                        <div className="day">{d.day}</div>
                        <div className="date">{d.date}</div>
                      </div>
                    ))}
                  </div>

                  <button className="nav-btn">›</button>

                </div>

                <Row>
                  <div className="col-md-6 mb-3">
                    <div className="meeting-card p-4">

                      {/* Header */}
                      <div className="d-flex align-items-center mb-4">
                        <div className="avatar me-3">AS</div>

                        <div>
                          <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                          <div className="text-muted">Marketing Trends & Analysis</div>
                        </div>
                      </div>

                      {/* Time Box */}
                      <div className="time-box d-flex align-items-center justify-content-center mb-4">

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>

                          <span className="time-text">10:30 AM</span>
                        </div>

                        <div className="divider mx-4"></div>

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>
                          <span className="time-text">11:30 AM</span>
                        </div>

                      </div>

                      {/* Buttons */}
                      <div className="row g-3">

                        <div className="col-md-6 col-6">
                          <button className="btn reject-btn w-100">
                            ✕ Reject
                          </button>
                        </div>

                        <div className="col-md-6 col-6">
                          <button className="btn accept-btn w-100">
                            ✓ Accept
                          </button>
                        </div>

                      </div>

                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="meeting-card p-4">

                      {/* Header */}
                      <div className="d-flex align-items-center mb-4">
                        <div className="avatar me-3">AS</div>

                        <div>
                          <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                          <div className="text-muted">Marketing Trends & Analysis</div>
                        </div>
                      </div>

                      {/* Time Box */}
                      <div className="time-box d-flex align-items-center justify-content-center mb-4">

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>

                          <span className="time-text">10:30 AM</span>
                        </div>

                        <div className="divider mx-4"></div>

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>
                          <span className="time-text">11:30 AM</span>
                        </div>

                      </div>

                      {/* Buttons */}
                      <div className="row g-3">

                        <div className="col-md-6 col-6">
                          <button className="btn reject-btn w-100">
                            ✕ Reject
                          </button>
                        </div>

                        <div className="col-md-6  col-6">
                          <button className="btn accept-btn w-100">
                            ✓ Accept
                          </button>
                        </div>

                      </div>

                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="meeting-card p-4">

                      {/* Header */}
                      <div className="d-flex align-items-center mb-4">
                        <div className="avatar me-3">AS</div>

                        <div>
                          <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                          <div className="text-muted">Marketing Trends & Analysis</div>
                        </div>
                      </div>

                      {/* Time Box */}
                      <div className="time-box d-flex align-items-center justify-content-center mb-4">

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>

                          <span className="time-text">10:30 AM</span>
                        </div>

                        <div className="divider mx-4"></div>

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>
                          <span className="time-text">11:30 AM</span>
                        </div>

                      </div>

                      {/* Buttons */}
                      <div className="row g-3">

                        <div className="col-md-6  col-6">
                          <button className="btn reject-btn w-100">
                            ✕ Reject
                          </button>
                        </div>

                        <div className="col-md-6  col-6">
                          <button className="btn accept-btn w-100">
                            ✓ Accept
                          </button>
                        </div>

                      </div>

                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="meeting-card p-4">

                      {/* Header */}
                      <div className="d-flex align-items-center mb-4">
                        <div className="avatar me-3">AS</div>

                        <div>
                          <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                          <div className="text-muted">Marketing Trends & Analysis</div>
                        </div>
                      </div>

                      {/* Time Box */}
                      <div className="time-box d-flex align-items-center justify-content-center mb-4">

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>

                          <span className="time-text">10:30 AM</span>
                        </div>

                        <div className="divider mx-4"></div>

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>
                          <span className="time-text">11:30 AM</span>
                        </div>

                      </div>

                      {/* Buttons */}
                      <div className="row g-3">

                        <div className="col-md-6  col-6">
                          <button className="btn reject-btn w-100">
                            ✕ Reject
                          </button>
                        </div>

                        <div className="col-md-6  col-6">
                          <button className="btn accept-btn w-100">
                            ✓ Accept
                          </button>
                        </div>

                      </div>

                    </div>
                  </div>
                </Row>

              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <Row>
                  <div className="col-md-6 mb-3">
                    <div className="meeting-card p-4">

                      {/* Header */}
                      <div className="d-flex align-items-center mb-4">
                        <div className="avatar me-3">AS</div>

                        <div>
                          <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                          <div className="text-muted">Marketing Trends & Analysis</div>
                        </div>
                      </div>

                      {/* Time Box */}
                      <div className="time-box d-flex align-items-center justify-content-center mb-4">

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>

                          <span className="time-text">10:30 AM</span>
                        </div>

                        <div className="divider mx-4"></div>

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>
                          <span className="time-text">11:30 AM</span>
                        </div>

                      </div>

                      {/* Buttons */}
                      <div className="row g-3">

                        <div className="col-md-12 col-12">
                          <button className="btn reject-btn w-100 zoom">
                            Collaborate with <svg width="61" height="13" viewBox="0 0 61 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_6936_11964)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M49.6653 3.89836C49.8985 4.27987 49.9748 4.71393 50 5.20191L50.0331 5.85232V10.4004L50.0669 11.0515C50.1345 12.1148 50.9614 12.901 52.0913 12.9679L52.7743 13V5.85232L52.8081 5.20191C52.8362 4.71939 52.9117 4.27714 53.1485 3.8929C53.3898 3.49879 53.7361 3.17181 54.1528 2.94478C54.5694 2.71776 55.0417 2.59868 55.5223 2.59951C56.0028 2.60034 56.4746 2.72105 56.8904 2.94951C57.3062 3.17797 57.6513 3.50615 57.8911 3.90109C58.1242 4.2826 58.1969 4.72485 58.225 5.20191L58.2588 5.85027V10.4004L58.2926 11.0515C58.3632 12.1203 59.1836 12.9065 60.317 12.9679L61 13V5.20191C61 3.823 60.4225 2.50053 59.3946 1.52529C58.3666 0.550062 56.9724 0.00190971 55.5183 0.0013668C54.7401 0.000588472 53.9707 0.157318 53.2614 0.461085C52.5521 0.764852 51.9194 1.20866 51.4055 1.76286C50.8913 1.20888 50.2585 0.765178 49.5493 0.461321C48.8401 0.157464 48.0708 0.000430302 47.2926 0.000684184C46.1541 0.000684184 45.0976 0.328278 44.2225 0.894059C43.6885 0.32896 42.4939 0.000684184 41.8081 0.000684184V13L42.4939 12.9679C43.641 12.8963 44.4701 12.1312 44.5147 11.0515L44.5514 10.4004V5.85232L44.5852 5.20191C44.614 4.7112 44.686 4.27987 44.9199 3.89563C45.1613 3.50177 45.5075 3.17486 45.9239 2.94756C46.3402 2.72025 46.8122 2.60051 47.2926 2.60027C47.7734 2.60037 48.2457 2.72036 48.6621 2.94819C49.0786 3.17603 49.4246 3.50371 49.6653 3.89836ZM2.74119 12.9686L3.42703 13H13.7074L13.6736 12.3516C13.5807 11.2829 12.7826 10.5021 11.652 10.4325L10.9662 10.4004H4.79871L13.0216 2.59959L12.9877 1.95191C12.9345 0.872219 12.1026 0.0921375 10.9662 0.0327608L10.2804 0.00341407L0 0.000684184L0.0338241 0.651094C0.123782 1.70963 0.933402 2.50677 2.05464 2.5682L2.74119 2.60027H8.9087L0.685838 10.4011L0.719662 11.0515C0.78731 12.123 1.60269 12.899 2.74119 12.9679V12.9686ZM39.1172 1.90346C39.7538 2.50699 40.2587 3.22353 40.6032 4.01216C40.9477 4.80078 41.125 5.64604 41.125 6.49966C41.125 7.35328 40.9477 8.19854 40.6032 8.98716C40.2587 9.77579 39.7538 10.4923 39.1172 11.0959C37.8312 12.3145 36.0876 12.999 34.2696 12.999C32.4516 12.999 30.708 12.3145 29.4219 11.0959C26.7455 8.5577 26.7455 4.44162 29.4219 1.90346C30.0579 1.30012 30.813 0.821492 31.644 0.494896C32.475 0.1683 33.3657 0.00013473 34.2653 1.56685e-06C35.1663 -0.00059167 36.0586 0.167278 36.8911 0.494008C37.7237 0.820738 38.4801 1.29992 39.1172 1.90414V1.90346ZM37.1777 3.74412C37.9487 4.47576 38.3817 5.46774 38.3817 6.50205C38.3817 7.53635 37.9487 8.52834 37.1777 9.25998C36.4063 9.99106 35.3602 10.4017 34.2696 10.4017C33.1789 10.4017 32.1329 9.99106 31.3614 9.25998C30.5905 8.52834 30.1575 7.53635 30.1575 6.50205C30.1575 5.46774 30.5905 4.47576 31.3614 3.74412C32.1329 3.01303 33.1789 2.60236 34.2696 2.60236C35.3602 2.60236 36.4063 3.01303 37.1777 3.74412ZM19.8807 1.56685e-06C20.7803 0.000224361 21.671 0.168498 22.502 0.495212C23.3331 0.821926 24.0881 1.30068 24.724 1.90414C27.4011 4.44162 27.4011 8.55838 24.724 11.0959C23.438 12.3145 21.6943 12.999 19.8763 12.999C18.0584 12.999 16.3147 12.3145 15.0287 11.0959C12.3523 8.5577 12.3523 4.44162 15.0287 1.90346C15.6647 1.30012 16.4197 0.821492 17.2507 0.494896C18.0818 0.1683 18.9725 0.00013473 19.872 1.56685e-06H19.8807ZM22.7845 3.74276C23.5556 4.47442 23.9888 5.46655 23.9888 6.50102C23.9888 7.5355 23.5556 8.52763 22.7845 9.25929C22.013 9.99038 20.967 10.4011 19.8763 10.4011C18.7857 10.4011 17.7397 9.99038 16.9682 9.25929C16.1973 8.52765 15.7642 7.53567 15.7642 6.50137C15.7642 5.46706 16.1973 4.47508 16.9682 3.74344C17.7397 3.01235 18.7857 2.60168 19.8763 2.60168C20.967 2.60168 22.013 3.01235 22.7845 3.74344V3.74276Z" fill="#2D8CFF" />
                              </g>
                              <defs>
                                <clipPath id="clip0_6936_11964">
                                  <rect width="61" height="13" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>

                          </button>
                        </div>


                      </div>

                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="meeting-card p-4">

                      {/* Header */}
                      <div className="d-flex align-items-center mb-4">
                        <div className="avatar me-3">AS</div>

                        <div>
                          <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                          <div className="text-muted">Marketing Trends & Analysis</div>
                        </div>
                      </div>

                      {/* Time Box */}
                      <div className="time-box d-flex align-items-center justify-content-center mb-4">

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>

                          <span className="time-text">10:30 AM</span>
                        </div>

                        <div className="divider mx-4"></div>

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>
                          <span className="time-text">11:30 AM</span>
                        </div>

                      </div>

                      {/* Buttons */}
                      <div className="row g-3">

                        <div className="col-md-12 col-12">
                          <button className="btn reject-btn w-100 zoom">
                            Collaborate with <svg width="61" height="13" viewBox="0 0 61 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_6936_11964)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M49.6653 3.89836C49.8985 4.27987 49.9748 4.71393 50 5.20191L50.0331 5.85232V10.4004L50.0669 11.0515C50.1345 12.1148 50.9614 12.901 52.0913 12.9679L52.7743 13V5.85232L52.8081 5.20191C52.8362 4.71939 52.9117 4.27714 53.1485 3.8929C53.3898 3.49879 53.7361 3.17181 54.1528 2.94478C54.5694 2.71776 55.0417 2.59868 55.5223 2.59951C56.0028 2.60034 56.4746 2.72105 56.8904 2.94951C57.3062 3.17797 57.6513 3.50615 57.8911 3.90109C58.1242 4.2826 58.1969 4.72485 58.225 5.20191L58.2588 5.85027V10.4004L58.2926 11.0515C58.3632 12.1203 59.1836 12.9065 60.317 12.9679L61 13V5.20191C61 3.823 60.4225 2.50053 59.3946 1.52529C58.3666 0.550062 56.9724 0.00190971 55.5183 0.0013668C54.7401 0.000588472 53.9707 0.157318 53.2614 0.461085C52.5521 0.764852 51.9194 1.20866 51.4055 1.76286C50.8913 1.20888 50.2585 0.765178 49.5493 0.461321C48.8401 0.157464 48.0708 0.000430302 47.2926 0.000684184C46.1541 0.000684184 45.0976 0.328278 44.2225 0.894059C43.6885 0.32896 42.4939 0.000684184 41.8081 0.000684184V13L42.4939 12.9679C43.641 12.8963 44.4701 12.1312 44.5147 11.0515L44.5514 10.4004V5.85232L44.5852 5.20191C44.614 4.7112 44.686 4.27987 44.9199 3.89563C45.1613 3.50177 45.5075 3.17486 45.9239 2.94756C46.3402 2.72025 46.8122 2.60051 47.2926 2.60027C47.7734 2.60037 48.2457 2.72036 48.6621 2.94819C49.0786 3.17603 49.4246 3.50371 49.6653 3.89836ZM2.74119 12.9686L3.42703 13H13.7074L13.6736 12.3516C13.5807 11.2829 12.7826 10.5021 11.652 10.4325L10.9662 10.4004H4.79871L13.0216 2.59959L12.9877 1.95191C12.9345 0.872219 12.1026 0.0921375 10.9662 0.0327608L10.2804 0.00341407L0 0.000684184L0.0338241 0.651094C0.123782 1.70963 0.933402 2.50677 2.05464 2.5682L2.74119 2.60027H8.9087L0.685838 10.4011L0.719662 11.0515C0.78731 12.123 1.60269 12.899 2.74119 12.9679V12.9686ZM39.1172 1.90346C39.7538 2.50699 40.2587 3.22353 40.6032 4.01216C40.9477 4.80078 41.125 5.64604 41.125 6.49966C41.125 7.35328 40.9477 8.19854 40.6032 8.98716C40.2587 9.77579 39.7538 10.4923 39.1172 11.0959C37.8312 12.3145 36.0876 12.999 34.2696 12.999C32.4516 12.999 30.708 12.3145 29.4219 11.0959C26.7455 8.5577 26.7455 4.44162 29.4219 1.90346C30.0579 1.30012 30.813 0.821492 31.644 0.494896C32.475 0.1683 33.3657 0.00013473 34.2653 1.56685e-06C35.1663 -0.00059167 36.0586 0.167278 36.8911 0.494008C37.7237 0.820738 38.4801 1.29992 39.1172 1.90414V1.90346ZM37.1777 3.74412C37.9487 4.47576 38.3817 5.46774 38.3817 6.50205C38.3817 7.53635 37.9487 8.52834 37.1777 9.25998C36.4063 9.99106 35.3602 10.4017 34.2696 10.4017C33.1789 10.4017 32.1329 9.99106 31.3614 9.25998C30.5905 8.52834 30.1575 7.53635 30.1575 6.50205C30.1575 5.46774 30.5905 4.47576 31.3614 3.74412C32.1329 3.01303 33.1789 2.60236 34.2696 2.60236C35.3602 2.60236 36.4063 3.01303 37.1777 3.74412ZM19.8807 1.56685e-06C20.7803 0.000224361 21.671 0.168498 22.502 0.495212C23.3331 0.821926 24.0881 1.30068 24.724 1.90414C27.4011 4.44162 27.4011 8.55838 24.724 11.0959C23.438 12.3145 21.6943 12.999 19.8763 12.999C18.0584 12.999 16.3147 12.3145 15.0287 11.0959C12.3523 8.5577 12.3523 4.44162 15.0287 1.90346C15.6647 1.30012 16.4197 0.821492 17.2507 0.494896C18.0818 0.1683 18.9725 0.00013473 19.872 1.56685e-06H19.8807ZM22.7845 3.74276C23.5556 4.47442 23.9888 5.46655 23.9888 6.50102C23.9888 7.5355 23.5556 8.52763 22.7845 9.25929C22.013 9.99038 20.967 10.4011 19.8763 10.4011C18.7857 10.4011 17.7397 9.99038 16.9682 9.25929C16.1973 8.52765 15.7642 7.53567 15.7642 6.50137C15.7642 5.46706 16.1973 4.47508 16.9682 3.74344C17.7397 3.01235 18.7857 2.60168 19.8763 2.60168C20.967 2.60168 22.013 3.01235 22.7845 3.74344V3.74276Z" fill="#2D8CFF" />
                              </g>
                              <defs>
                                <clipPath id="clip0_6936_11964">
                                  <rect width="61" height="13" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>

                          </button>
                        </div>



                      </div>

                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="meeting-card p-4">

                      {/* Header */}
                      <div className="d-flex align-items-center mb-4">
                        <div className="avatar me-3">AS</div>

                        <div>
                          <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                          <div className="text-muted">Marketing Trends & Analysis</div>
                        </div>
                      </div>

                      {/* Time Box */}
                      <div className="time-box d-flex align-items-center justify-content-center mb-4">

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>

                          <span className="time-text">10:30 AM</span>
                        </div>

                        <div className="divider mx-4"></div>

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>
                          <span className="time-text">11:30 AM</span>
                        </div>

                      </div>

                      {/* Buttons */}
                      <div className="row g-3">

                        <div className="col-md-12 col-12">
                          <button className="btn reject-btn w-100 zoom">
                            Collaborate with <svg width="61" height="13" viewBox="0 0 61 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_6936_11964)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M49.6653 3.89836C49.8985 4.27987 49.9748 4.71393 50 5.20191L50.0331 5.85232V10.4004L50.0669 11.0515C50.1345 12.1148 50.9614 12.901 52.0913 12.9679L52.7743 13V5.85232L52.8081 5.20191C52.8362 4.71939 52.9117 4.27714 53.1485 3.8929C53.3898 3.49879 53.7361 3.17181 54.1528 2.94478C54.5694 2.71776 55.0417 2.59868 55.5223 2.59951C56.0028 2.60034 56.4746 2.72105 56.8904 2.94951C57.3062 3.17797 57.6513 3.50615 57.8911 3.90109C58.1242 4.2826 58.1969 4.72485 58.225 5.20191L58.2588 5.85027V10.4004L58.2926 11.0515C58.3632 12.1203 59.1836 12.9065 60.317 12.9679L61 13V5.20191C61 3.823 60.4225 2.50053 59.3946 1.52529C58.3666 0.550062 56.9724 0.00190971 55.5183 0.0013668C54.7401 0.000588472 53.9707 0.157318 53.2614 0.461085C52.5521 0.764852 51.9194 1.20866 51.4055 1.76286C50.8913 1.20888 50.2585 0.765178 49.5493 0.461321C48.8401 0.157464 48.0708 0.000430302 47.2926 0.000684184C46.1541 0.000684184 45.0976 0.328278 44.2225 0.894059C43.6885 0.32896 42.4939 0.000684184 41.8081 0.000684184V13L42.4939 12.9679C43.641 12.8963 44.4701 12.1312 44.5147 11.0515L44.5514 10.4004V5.85232L44.5852 5.20191C44.614 4.7112 44.686 4.27987 44.9199 3.89563C45.1613 3.50177 45.5075 3.17486 45.9239 2.94756C46.3402 2.72025 46.8122 2.60051 47.2926 2.60027C47.7734 2.60037 48.2457 2.72036 48.6621 2.94819C49.0786 3.17603 49.4246 3.50371 49.6653 3.89836ZM2.74119 12.9686L3.42703 13H13.7074L13.6736 12.3516C13.5807 11.2829 12.7826 10.5021 11.652 10.4325L10.9662 10.4004H4.79871L13.0216 2.59959L12.9877 1.95191C12.9345 0.872219 12.1026 0.0921375 10.9662 0.0327608L10.2804 0.00341407L0 0.000684184L0.0338241 0.651094C0.123782 1.70963 0.933402 2.50677 2.05464 2.5682L2.74119 2.60027H8.9087L0.685838 10.4011L0.719662 11.0515C0.78731 12.123 1.60269 12.899 2.74119 12.9679V12.9686ZM39.1172 1.90346C39.7538 2.50699 40.2587 3.22353 40.6032 4.01216C40.9477 4.80078 41.125 5.64604 41.125 6.49966C41.125 7.35328 40.9477 8.19854 40.6032 8.98716C40.2587 9.77579 39.7538 10.4923 39.1172 11.0959C37.8312 12.3145 36.0876 12.999 34.2696 12.999C32.4516 12.999 30.708 12.3145 29.4219 11.0959C26.7455 8.5577 26.7455 4.44162 29.4219 1.90346C30.0579 1.30012 30.813 0.821492 31.644 0.494896C32.475 0.1683 33.3657 0.00013473 34.2653 1.56685e-06C35.1663 -0.00059167 36.0586 0.167278 36.8911 0.494008C37.7237 0.820738 38.4801 1.29992 39.1172 1.90414V1.90346ZM37.1777 3.74412C37.9487 4.47576 38.3817 5.46774 38.3817 6.50205C38.3817 7.53635 37.9487 8.52834 37.1777 9.25998C36.4063 9.99106 35.3602 10.4017 34.2696 10.4017C33.1789 10.4017 32.1329 9.99106 31.3614 9.25998C30.5905 8.52834 30.1575 7.53635 30.1575 6.50205C30.1575 5.46774 30.5905 4.47576 31.3614 3.74412C32.1329 3.01303 33.1789 2.60236 34.2696 2.60236C35.3602 2.60236 36.4063 3.01303 37.1777 3.74412ZM19.8807 1.56685e-06C20.7803 0.000224361 21.671 0.168498 22.502 0.495212C23.3331 0.821926 24.0881 1.30068 24.724 1.90414C27.4011 4.44162 27.4011 8.55838 24.724 11.0959C23.438 12.3145 21.6943 12.999 19.8763 12.999C18.0584 12.999 16.3147 12.3145 15.0287 11.0959C12.3523 8.5577 12.3523 4.44162 15.0287 1.90346C15.6647 1.30012 16.4197 0.821492 17.2507 0.494896C18.0818 0.1683 18.9725 0.00013473 19.872 1.56685e-06H19.8807ZM22.7845 3.74276C23.5556 4.47442 23.9888 5.46655 23.9888 6.50102C23.9888 7.5355 23.5556 8.52763 22.7845 9.25929C22.013 9.99038 20.967 10.4011 19.8763 10.4011C18.7857 10.4011 17.7397 9.99038 16.9682 9.25929C16.1973 8.52765 15.7642 7.53567 15.7642 6.50137C15.7642 5.46706 16.1973 4.47508 16.9682 3.74344C17.7397 3.01235 18.7857 2.60168 19.8763 2.60168C20.967 2.60168 22.013 3.01235 22.7845 3.74344V3.74276Z" fill="#2D8CFF" />
                              </g>
                              <defs>
                                <clipPath id="clip0_6936_11964">
                                  <rect width="61" height="13" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>

                          </button>
                        </div>



                      </div>

                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="meeting-card p-4">

                      {/* Header */}
                      <div className="d-flex align-items-center mb-4">
                        <div className="avatar me-3">AS</div>

                        <div>
                          <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                          <div className="text-muted">Marketing Trends & Analysis</div>
                        </div>
                      </div>

                      {/* Time Box */}
                      <div className="time-box d-flex align-items-center justify-content-center mb-4">

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>

                          <span className="time-text">10:30 AM</span>
                        </div>

                        <div className="divider mx-4"></div>

                        <div className="d-flex align-items-center gap-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_6936_10428" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                              <path d="M15.9836 0H0V15.9836H15.9836V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_6936_10428)">
                              <path d="M7.99189 14.6517C11.67 14.6517 14.6517 11.67 14.6517 7.99189C14.6517 4.31375 11.67 1.33203 7.99189 1.33203C4.31375 1.33203 1.33203 4.31375 1.33203 7.99189C1.33203 11.67 4.31375 14.6517 7.99189 14.6517Z" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.99194 3.99609V7.99201L10.6559 9.32398" stroke="#66C15E" stroke-width="1.33197" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                          </svg>
                          <span className="time-text">11:30 AM</span>
                        </div>

                      </div>

                      {/* Buttons */}
                      <div className="row g-3">

                        <div className="col-md-12  col-12">
                          <button className="btn reject-btn w-100">
                            ✕ Cancel
                          </button>
                        </div>


                      </div>

                    </div>
                  </div>
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="three">     <Row>
                <div className="col-md-6 mb-3">
                  <div className="meeting-card p-4">
                    {/* Header */}
                    <div className="d-flex align-items-start mb-0">
                      <div className="avatar me-3">AS</div>

                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1 justify-content-between">
                          <div><h5 className="mb-1 fw-bold">Aisha Singh</h5></div>
                          <div>asdf</div>
                          </div>
                        
                        <div className="">Business Strategy & Growth</div>
                        <div className="d-flex gap-2 mt-2">
                          <span className=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.42312 17.9157C4.00215 17.9157 3.64583 17.7699 3.35416 17.4782C3.0625 17.1865 2.91666 16.8302 2.91666 16.4092V5.25549C2.91666 4.83452 3.0625 4.4782 3.35416 4.18654C3.64583 3.89487 4.00215 3.74904 4.42312 3.74904H5.57687V1.98633H6.85896V3.74904H13.1731V1.98633H14.4231V3.74904H15.5769C15.9978 3.74904 16.3542 3.89487 16.6458 4.18654C16.9375 4.4782 17.0833 4.83452 17.0833 5.25549V16.4092C17.0833 16.8302 16.9375 17.1865 16.6458 17.4782C16.3542 17.7699 15.9978 17.9157 15.5769 17.9157H4.42312ZM4.42312 16.6657H15.5769C15.641 16.6657 15.6998 16.639 15.7531 16.5855C15.8066 16.5322 15.8333 16.4734 15.8333 16.4092V8.58883H4.16666V16.4092C4.16666 16.4734 4.1934 16.5322 4.24687 16.5855C4.30021 16.639 4.35896 16.6657 4.42312 16.6657ZM4.16666 7.33883H15.8333V5.25549C15.8333 5.19133 15.8066 5.13258 15.7531 5.07924C15.6998 5.02577 15.641 4.99904 15.5769 4.99904H4.42312C4.35896 4.99904 4.30021 5.02577 4.24687 5.07924C4.1934 5.13258 4.16666 5.19133 4.16666 5.25549V7.33883Z" fill="#5E5E5E" />
                          </svg>&nbsp;

                            12 Jan 2026</span>
                          <span className=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.8942 13.7732L13.7725 12.8948L10.625 9.74732V5.83398H9.375V10.2538L12.8942 13.7732ZM10.0015 17.9173C8.90645 17.9173 7.87722 17.7095 6.91374 17.294C5.95027 16.8784 5.11222 16.3145 4.39958 15.6021C3.68694 14.8897 3.1227 14.052 2.70687 13.089C2.29118 12.1259 2.08333 11.097 2.08333 10.0021C2.08333 8.90711 2.29111 7.87787 2.70666 6.9144C3.12222 5.95093 3.68618 5.11287 4.39854 4.40023C5.1109 3.6876 5.94861 3.12336 6.91166 2.70753C7.87472 2.29183 8.90368 2.08398 9.99854 2.08398C11.0935 2.08398 12.1228 2.29176 13.0862 2.70732C14.0497 3.12287 14.8878 3.68683 15.6004 4.39919C16.3131 5.11155 16.8773 5.94926 17.2931 6.91232C17.7088 7.87537 17.9167 8.90433 17.9167 9.99919C17.9167 11.0942 17.7089 12.1234 17.2933 13.0869C16.8778 14.0504 16.3138 14.8884 15.6015 15.6011C14.8891 16.3137 14.0514 16.8779 13.0883 17.2938C12.1253 17.7095 11.0963 17.9173 10.0015 17.9173ZM10 16.6673C11.8472 16.6673 13.4201 16.018 14.7187 14.7194C16.0174 13.4208 16.6667 11.8479 16.6667 10.0007C16.6667 8.15343 16.0174 6.58051 14.7187 5.2819C13.4201 3.98329 11.8472 3.33398 10 3.33398C8.15277 3.33398 6.57986 3.98329 5.28124 5.2819C3.98263 6.58051 3.33333 8.15343 3.33333 10.0007C3.33333 11.8479 3.98263 13.4208 5.28124 14.7194C6.57986 16.018 8.15277 16.6673 10 16.6673Z" fill="#5E5E5E" />
                          </svg>
                            &nbsp;1:00 PM - 2:00 PM</span>
                        </div>
                        <div className="d-flex gap-2 mt-2">
                          <span className="d-flex gap-2 align-items-center"><h4><b>₹ 5000</b> </h4> <Badge className="badge-pending">Pending</Badge></span>
                          <span className="">
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  <div className="col-md-6 mb-3">
                  <div className="meeting-card p-4">
                    {/* Header */}
                    <div className="d-flex align-items-start mb-0">
                      <div className="avatar me-3">AS</div>

                      <div>
                        <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                        <div className="">Business Strategy & Growth</div>
                        <div className="d-flex gap-2 mt-2">
                          <span className=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.42312 17.9157C4.00215 17.9157 3.64583 17.7699 3.35416 17.4782C3.0625 17.1865 2.91666 16.8302 2.91666 16.4092V5.25549C2.91666 4.83452 3.0625 4.4782 3.35416 4.18654C3.64583 3.89487 4.00215 3.74904 4.42312 3.74904H5.57687V1.98633H6.85896V3.74904H13.1731V1.98633H14.4231V3.74904H15.5769C15.9978 3.74904 16.3542 3.89487 16.6458 4.18654C16.9375 4.4782 17.0833 4.83452 17.0833 5.25549V16.4092C17.0833 16.8302 16.9375 17.1865 16.6458 17.4782C16.3542 17.7699 15.9978 17.9157 15.5769 17.9157H4.42312ZM4.42312 16.6657H15.5769C15.641 16.6657 15.6998 16.639 15.7531 16.5855C15.8066 16.5322 15.8333 16.4734 15.8333 16.4092V8.58883H4.16666V16.4092C4.16666 16.4734 4.1934 16.5322 4.24687 16.5855C4.30021 16.639 4.35896 16.6657 4.42312 16.6657ZM4.16666 7.33883H15.8333V5.25549C15.8333 5.19133 15.8066 5.13258 15.7531 5.07924C15.6998 5.02577 15.641 4.99904 15.5769 4.99904H4.42312C4.35896 4.99904 4.30021 5.02577 4.24687 5.07924C4.1934 5.13258 4.16666 5.19133 4.16666 5.25549V7.33883Z" fill="#5E5E5E" />
                          </svg>&nbsp;

                            12 Jan 2026</span>
                          <span className=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.8942 13.7732L13.7725 12.8948L10.625 9.74732V5.83398H9.375V10.2538L12.8942 13.7732ZM10.0015 17.9173C8.90645 17.9173 7.87722 17.7095 6.91374 17.294C5.95027 16.8784 5.11222 16.3145 4.39958 15.6021C3.68694 14.8897 3.1227 14.052 2.70687 13.089C2.29118 12.1259 2.08333 11.097 2.08333 10.0021C2.08333 8.90711 2.29111 7.87787 2.70666 6.9144C3.12222 5.95093 3.68618 5.11287 4.39854 4.40023C5.1109 3.6876 5.94861 3.12336 6.91166 2.70753C7.87472 2.29183 8.90368 2.08398 9.99854 2.08398C11.0935 2.08398 12.1228 2.29176 13.0862 2.70732C14.0497 3.12287 14.8878 3.68683 15.6004 4.39919C16.3131 5.11155 16.8773 5.94926 17.2931 6.91232C17.7088 7.87537 17.9167 8.90433 17.9167 9.99919C17.9167 11.0942 17.7089 12.1234 17.2933 13.0869C16.8778 14.0504 16.3138 14.8884 15.6015 15.6011C14.8891 16.3137 14.0514 16.8779 13.0883 17.2938C12.1253 17.7095 11.0963 17.9173 10.0015 17.9173ZM10 16.6673C11.8472 16.6673 13.4201 16.018 14.7187 14.7194C16.0174 13.4208 16.6667 11.8479 16.6667 10.0007C16.6667 8.15343 16.0174 6.58051 14.7187 5.2819C13.4201 3.98329 11.8472 3.33398 10 3.33398C8.15277 3.33398 6.57986 3.98329 5.28124 5.2819C3.98263 6.58051 3.33333 8.15343 3.33333 10.0007C3.33333 11.8479 3.98263 13.4208 5.28124 14.7194C6.57986 16.018 8.15277 16.6673 10 16.6673Z" fill="#5E5E5E" />
                          </svg>
                            &nbsp;1:00 PM - 2:00 PM</span>
                        </div>
                        <div className="d-flex gap-2 mt-2">
                          <span className="d-flex gap-2 align-items-center"><h4><b>₹ 5000</b> </h4> <Badge className="badge-pending">Pending</Badge></span>
                          <span className="">
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  <div className="col-md-6 mb-3">
                  <div className="meeting-card p-4">
                    {/* Header */}
                    <div className="d-flex align-items-start mb-0">
                      <div className="avatar me-3">AS</div>

                      <div>
                        <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                        <div className="">Business Strategy & Growth</div>
                        <div className="d-flex gap-2 mt-2">
                          <span className=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.42312 17.9157C4.00215 17.9157 3.64583 17.7699 3.35416 17.4782C3.0625 17.1865 2.91666 16.8302 2.91666 16.4092V5.25549C2.91666 4.83452 3.0625 4.4782 3.35416 4.18654C3.64583 3.89487 4.00215 3.74904 4.42312 3.74904H5.57687V1.98633H6.85896V3.74904H13.1731V1.98633H14.4231V3.74904H15.5769C15.9978 3.74904 16.3542 3.89487 16.6458 4.18654C16.9375 4.4782 17.0833 4.83452 17.0833 5.25549V16.4092C17.0833 16.8302 16.9375 17.1865 16.6458 17.4782C16.3542 17.7699 15.9978 17.9157 15.5769 17.9157H4.42312ZM4.42312 16.6657H15.5769C15.641 16.6657 15.6998 16.639 15.7531 16.5855C15.8066 16.5322 15.8333 16.4734 15.8333 16.4092V8.58883H4.16666V16.4092C4.16666 16.4734 4.1934 16.5322 4.24687 16.5855C4.30021 16.639 4.35896 16.6657 4.42312 16.6657ZM4.16666 7.33883H15.8333V5.25549C15.8333 5.19133 15.8066 5.13258 15.7531 5.07924C15.6998 5.02577 15.641 4.99904 15.5769 4.99904H4.42312C4.35896 4.99904 4.30021 5.02577 4.24687 5.07924C4.1934 5.13258 4.16666 5.19133 4.16666 5.25549V7.33883Z" fill="#5E5E5E" />
                          </svg>&nbsp;

                            12 Jan 2026</span>
                          <span className=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.8942 13.7732L13.7725 12.8948L10.625 9.74732V5.83398H9.375V10.2538L12.8942 13.7732ZM10.0015 17.9173C8.90645 17.9173 7.87722 17.7095 6.91374 17.294C5.95027 16.8784 5.11222 16.3145 4.39958 15.6021C3.68694 14.8897 3.1227 14.052 2.70687 13.089C2.29118 12.1259 2.08333 11.097 2.08333 10.0021C2.08333 8.90711 2.29111 7.87787 2.70666 6.9144C3.12222 5.95093 3.68618 5.11287 4.39854 4.40023C5.1109 3.6876 5.94861 3.12336 6.91166 2.70753C7.87472 2.29183 8.90368 2.08398 9.99854 2.08398C11.0935 2.08398 12.1228 2.29176 13.0862 2.70732C14.0497 3.12287 14.8878 3.68683 15.6004 4.39919C16.3131 5.11155 16.8773 5.94926 17.2931 6.91232C17.7088 7.87537 17.9167 8.90433 17.9167 9.99919C17.9167 11.0942 17.7089 12.1234 17.2933 13.0869C16.8778 14.0504 16.3138 14.8884 15.6015 15.6011C14.8891 16.3137 14.0514 16.8779 13.0883 17.2938C12.1253 17.7095 11.0963 17.9173 10.0015 17.9173ZM10 16.6673C11.8472 16.6673 13.4201 16.018 14.7187 14.7194C16.0174 13.4208 16.6667 11.8479 16.6667 10.0007C16.6667 8.15343 16.0174 6.58051 14.7187 5.2819C13.4201 3.98329 11.8472 3.33398 10 3.33398C8.15277 3.33398 6.57986 3.98329 5.28124 5.2819C3.98263 6.58051 3.33333 8.15343 3.33333 10.0007C3.33333 11.8479 3.98263 13.4208 5.28124 14.7194C6.57986 16.018 8.15277 16.6673 10 16.6673Z" fill="#5E5E5E" />
                          </svg>
                            &nbsp;1:00 PM - 2:00 PM</span>
                        </div>
                        <div className="d-flex gap-2 mt-2">
                          <span className="d-flex gap-2 align-items-center"><h4><b>₹ 5000</b> </h4> <Badge className="badge-pending">Pending</Badge></span>
                          <span className="">
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  <div className="col-md-6 mb-3">
                  <div className="meeting-card p-4">
                    {/* Header */}
                    <div className="d-flex align-items-start mb-0">
                      <div className="avatar me-3">AS</div>

                      <div>
                        <h5 className="mb-1 fw-bold">Aisha Singh</h5>
                        <div className="">Business Strategy & Growth</div>
                        <div className="d-flex gap-2 mt-2">
                          <span className=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.42312 17.9157C4.00215 17.9157 3.64583 17.7699 3.35416 17.4782C3.0625 17.1865 2.91666 16.8302 2.91666 16.4092V5.25549C2.91666 4.83452 3.0625 4.4782 3.35416 4.18654C3.64583 3.89487 4.00215 3.74904 4.42312 3.74904H5.57687V1.98633H6.85896V3.74904H13.1731V1.98633H14.4231V3.74904H15.5769C15.9978 3.74904 16.3542 3.89487 16.6458 4.18654C16.9375 4.4782 17.0833 4.83452 17.0833 5.25549V16.4092C17.0833 16.8302 16.9375 17.1865 16.6458 17.4782C16.3542 17.7699 15.9978 17.9157 15.5769 17.9157H4.42312ZM4.42312 16.6657H15.5769C15.641 16.6657 15.6998 16.639 15.7531 16.5855C15.8066 16.5322 15.8333 16.4734 15.8333 16.4092V8.58883H4.16666V16.4092C4.16666 16.4734 4.1934 16.5322 4.24687 16.5855C4.30021 16.639 4.35896 16.6657 4.42312 16.6657ZM4.16666 7.33883H15.8333V5.25549C15.8333 5.19133 15.8066 5.13258 15.7531 5.07924C15.6998 5.02577 15.641 4.99904 15.5769 4.99904H4.42312C4.35896 4.99904 4.30021 5.02577 4.24687 5.07924C4.1934 5.13258 4.16666 5.19133 4.16666 5.25549V7.33883Z" fill="#5E5E5E" />
                          </svg>&nbsp;

                            12 Jan 2026</span>
                          <span className=""><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.8942 13.7732L13.7725 12.8948L10.625 9.74732V5.83398H9.375V10.2538L12.8942 13.7732ZM10.0015 17.9173C8.90645 17.9173 7.87722 17.7095 6.91374 17.294C5.95027 16.8784 5.11222 16.3145 4.39958 15.6021C3.68694 14.8897 3.1227 14.052 2.70687 13.089C2.29118 12.1259 2.08333 11.097 2.08333 10.0021C2.08333 8.90711 2.29111 7.87787 2.70666 6.9144C3.12222 5.95093 3.68618 5.11287 4.39854 4.40023C5.1109 3.6876 5.94861 3.12336 6.91166 2.70753C7.87472 2.29183 8.90368 2.08398 9.99854 2.08398C11.0935 2.08398 12.1228 2.29176 13.0862 2.70732C14.0497 3.12287 14.8878 3.68683 15.6004 4.39919C16.3131 5.11155 16.8773 5.94926 17.2931 6.91232C17.7088 7.87537 17.9167 8.90433 17.9167 9.99919C17.9167 11.0942 17.7089 12.1234 17.2933 13.0869C16.8778 14.0504 16.3138 14.8884 15.6015 15.6011C14.8891 16.3137 14.0514 16.8779 13.0883 17.2938C12.1253 17.7095 11.0963 17.9173 10.0015 17.9173ZM10 16.6673C11.8472 16.6673 13.4201 16.018 14.7187 14.7194C16.0174 13.4208 16.6667 11.8479 16.6667 10.0007C16.6667 8.15343 16.0174 6.58051 14.7187 5.2819C13.4201 3.98329 11.8472 3.33398 10 3.33398C8.15277 3.33398 6.57986 3.98329 5.28124 5.2819C3.98263 6.58051 3.33333 8.15343 3.33333 10.0007C3.33333 11.8479 3.98263 13.4208 5.28124 14.7194C6.57986 16.018 8.15277 16.6673 10 16.6673Z" fill="#5E5E5E" />
                          </svg>
                            &nbsp;1:00 PM - 2:00 PM</span>
                        </div>
                        <div className="d-flex gap-2 mt-2">
                            <span className="d-flex gap-2 align-items-center"><h4><b>₹ 5000</b> </h4> <Badge className="badge-pending">Pending</Badge></span>
                          <span className="">
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </Row></Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>



    </div>
  );
}
